/**
 * DSGVO/TDDDG-compliant consent state for MIBAX Messtechnik.
 *
 * Loads marketing scripts (PostHog, LinkedIn Insight Tag) ONLY after the
 * visitor grants explicit consent — nothing tracks-y runs on first page
 * load. Consent persists in localStorage under a versioned key so we can
 * invalidate stale consents when the tracking set changes.
 */

export const CONSENT_KEY = 'mibax_consent_v1';
export const REOPEN_EVENT = 'mibax:reopen-consent';

const POSTHOG_TOKEN = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
const POSTHOG_HOST = 'https://us.i.posthog.com';
const LINKEDIN_PARTNER_ID = '10751249';

let marketingLoaded = false;

export function readConsent() {
  try {
    const raw = window.localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.marketing !== 'boolean') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent(marketing) {
  const consent = { marketing: !!marketing, timestamp: new Date().toISOString() };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch {
    // localStorage disabled (private mode etc.) — treat as session-only.
  }
  if (consent.marketing) loadMarketingScripts();
  return consent;
}

export function reopenBanner() {
  window.dispatchEvent(new CustomEvent(REOPEN_EVENT));
}

export function loadMarketingScripts() {
  if (marketingLoaded) return;
  marketingLoaded = true;
  loadPostHog();
  loadLinkedInInsight();
}

// ---------- PostHog ----------
function loadPostHog() {
  // Stub + async loader (canonical PostHog snippet, condensed).
  (function (t, e) {
    if (e.__SV) return;
    window.posthog = e;
    e._i = [];
    e.init = function (i, s, a) {
      function g(t, e) {
        const o = e.split('.');
        if (o.length === 2) {
          t = t[o[0]];
          e = o[1];
        }
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      const p = t.createElement('script');
      p.type = 'text/javascript';
      p.crossOrigin = 'anonymous';
      p.async = true;
      p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
      const r = t.getElementsByTagName('script')[0];
      r.parentNode.insertBefore(p, r);
      let u = e;
      if (a !== undefined) u = e[a] = [];
      else a = 'posthog';
      u.people = u.people || [];
      u.toString = function (t) {
        let n = 'posthog';
        if (a !== 'posthog') n += '.' + a;
        if (!t) n += ' (stub)';
        return n;
      };
      u.people.toString = function () {
        return u.toString(1) + '.people (stub)';
      };
      const methods = 'init capture identify alias set_config register register_once unregister opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing get_distinct_id reset startSessionRecording stopSessionRecording'.split(' ');
      for (let n = 0; n < methods.length; n++) g(u, methods[n]);
      e._i.push([i, s, a]);
    };
    e.__SV = 1;
  })(document, window.posthog || []);
  window.posthog.init(POSTHOG_TOKEN, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
    session_recording: { recordCrossOriginIframes: true, capturePerformance: false },
  });
}

// ---------- LinkedIn Insight Tag ----------
function loadLinkedInInsight() {
  window._linkedin_partner_id = LINKEDIN_PARTNER_ID;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(LINKEDIN_PARTNER_ID);
  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    const s = document.getElementsByTagName('script')[0];
    const b = document.createElement('script');
    b.type = 'text/javascript';
    b.async = true;
    b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
}
